module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS018B7DH02-2-25-19.34bb4ffb.pdf";